import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button, App, Steps, Card } from 'antd';
import { useAuth } from '../../context/AuthContext';
import './Payment.scss';

const PLANS = [
  {
    key: 'basic',
    name: '基础勘察',
    price: 299,
    desc: '房屋结构勘验 + 基础问题排查',
    features: ['上门实地勘察', '房屋结构检测', '水电管线初步检查', '出具基础勘察报告', '7个工作日内交付'],
    popular: false,
  },
  {
    key: 'standard',
    name: '标准勘察',
    price: 599,
    desc: '全面装修现场勘验 + 详细报告',
    features: ['上门实地勘察', '房屋结构与隐蔽工程检测', '水电/防水/墙面全面检查', '装修建议方案', '详细勘察报告（含照片）', '5个工作日内交付'],
    popular: true,
  },
  {
    key: 'premium',
    name: '深度勘察',
    price: 999,
    desc: '全方位深度勘验 + 专家解读',
    features: ['上门实地勘察', '全屋深度检测（含仪器）', '隐蔽工程全面排查', '环保指标初步评估', '个性化装修建议', '专家一对一报告解读', '3个工作日内交付'],
    popular: false,
  },
];

function Payment() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { message } = App.useApp();
  const [selectedPlan, setSelectedPlan] = useState('standard');
  const [step, setStep] = useState(0);
  const [paying, setPaying] = useState(false);

  // 未登录拦截
  if (!user) {
    return (
      <div className="payment-page">
        <div className="container">
          <div className="payment-card payment-center">
            <h1>请先登录</h1>
            <p>付费咨询服务需要您先登录账号</p>
            <Button type="primary" size="large" onClick={() => navigate('/login?redirect=/payment')}>
              去登录
            </Button>
          </div>
        </div>
      </div>
    );
  }

  const currentPlan = PLANS.find((p) => p.key === selectedPlan);

  const handlePay = () => {
    if (step === 0) {
      setStep(1);
      return;
    }
    setPaying(true);
    // 模拟支付流程
    setTimeout(() => {
      setPaying(false);
      setStep(2);
      message.success('支付成功！我们的工程师将尽快与您联系确认上门时间。');
    }, 1500);
  };

  return (
    <div className="payment-page">
      <div className="container">
        {/* 面包屑 */}
        <div className="detail-crumb">
          <Link to="/">首页</Link>
          <span>/</span>
          <Link to="/services">产品服务</Link>
          <span>/</span>
          <em>付费咨询 - 勘察服务</em>
        </div>

        <h1 className="payment-title">勘察服务 · 付费咨询</h1>
        <p className="payment-sub">
          专业团队上门对房屋装修现场进行全面勘验，为您的装修决策提供专业依据
        </p>

        {/* 步骤条 */}
        <Steps
          current={step}
          items={[
            { title: '选择方案' },
            { title: '确认支付' },
            { title: '支付完成' },
          ]}
          className="payment-steps"
        />

        {/* 步骤内容 */}
        {step === 0 && (
          <div className="plan-grid">
            {PLANS.map((plan) => (
              <div
                key={plan.key}
                className={`plan-card ${selectedPlan === plan.key ? 'plan-selected' : ''} ${plan.popular ? 'plan-popular' : ''}`}
                onClick={() => setSelectedPlan(plan.key)}
              >
                {plan.popular && <span className="plan-badge">推荐</span>}
                <h3>{plan.name}</h3>
                <div className="plan-price">
                  <span className="price-num">¥{plan.price}</span>
                  <span className="price-unit"> / 次</span>
                </div>
                <p className="plan-desc">{plan.desc}</p>
                <ul className="plan-features">
                  {plan.features.map((f) => (
                    <li key={f}>✓ {f}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}

        {step === 1 && currentPlan && (
          <div className="payment-confirm">
            <Card title="订单确认" className="confirm-card">
              <div className="confirm-row">
                <span className="confirm-label">服务项目</span>
                <span className="confirm-value">{currentPlan.name}</span>
              </div>
              <div className="confirm-row">
                <span className="confirm-label">服务说明</span>
                <span className="confirm-value">{currentPlan.desc}</span>
              </div>
              <div className="confirm-row confirm-total">
                <span className="confirm-label">支付金额</span>
                <span className="confirm-value confirm-price">¥{currentPlan.price}</span>
              </div>
            </Card>
          </div>
        )}

        {step === 2 && (
          <div className="payment-success">
            <div className="success-icon">✅</div>
            <h2>支付成功！</h2>
            <p>感谢您的支付，我们的工程师将在 24 小时内与您联系，确认上门勘察时间。</p>
            <p className="success-sub">您也可以在「会员中心」查看订单状态。</p>
          </div>
        )}

        {/* 操作按钮 */}
        <div className="payment-actions">
          {step > 0 && step < 2 && (
            <Button size="large" onClick={() => setStep(step - 1)}>
              上一步
            </Button>
          )}
          {step < 2 && (
            <Button type="primary" size="large" loading={paying} onClick={handlePay}>
              {step === 0 ? '选择并继续' : '确认支付'}
            </Button>
          )}
          {step === 2 && (
            <Button type="primary" size="large" onClick={() => navigate('/account')}>
              查看我的订单
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Payment;
